import styled from "styled-components/macro";

import { colors } from "UI/colors";

export const MenuButton = styled.button`
  border: none;
  border-radius: 3px;
  background: transparent;
  width: 41px;
  font-size: 17px;
  color: #5a5a5a;
  margin-right: 3px;
  cursor: pointer;
  transition: color 150ms, background 150ms;

  &.is-active {
    color: rgba(0, 0, 0, 0.9);
    background: rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    color: ${colors.fnBlueHover};
  }
`;
